import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PassengerDetailsItem from './components/passengerdetailsitem';
import { initialize, getFormValues } from 'redux-form';
import { FetchNationality, FetchNationalityState } from '../../actions/nationality';
import _filter from 'lodash/filter';
import _forEach from 'lodash/forEach';

class PassengerDetails extends PureComponent{

  constructor(props){
    super(props);
    this.state = {
      stateVisible:false,
      currentState:""
    }
  }

  componentDidMount(){

    const { bookingGroup, FetchNationality, FetchNationalityState, nationality, nationalityState } = this.props;

    //Populate paxDetails (bookingGroup in state)
    if(bookingGroup.passengers !== undefined){
      this.populatePaxDetails(bookingGroup);
    }

    //Fetch nationality / state
    if(nationality.length === 0) FetchNationality();
    if(nationalityState.length === 0) FetchNationalityState();


    //Populate passsenger details
    setTimeout(() => {
      _forEach(document.querySelectorAll('.passenger-details-item input'),item => {
        if(item.value !== "") {
          item.parentElement.parentElement.classList.add('hovered');
        }
      });
    },10);

  }

  componentDidUpdate(prevProps, prevState) {

      const { bookingGroup, paxDetailsValues } = this.props;


      //Populate pax details (bookingGroup loaded)
      if(bookingGroup !== prevProps.bookingGroup){
        this.populatePaxDetails(bookingGroup);
      }

      //Toggle visibility for state dropdown if Canada or USA
      if(paxDetailsValues !== prevProps.paxDetailsValues){

        if(paxDetailsValues.nationality === "US" || paxDetailsValues.nationality === "CA"){
          this.setState({stateVisible:true, currentState:paxDetailsValues.nationality});
        }else{
          this.setState({stateVisible:false, currentState:""});
        }
      }

  }

  populatePaxDetails(bookingGroup){
    if(bookingGroup.passengers.length !== 0){


      //initalise PassengerDetails form from bookingGroup payload
      const loadedPhonePrefix = (this.props.paxDetailsValues === undefined) ? "" : this.props.paxDetailsValues.phonePrefix;
      const loadedPhone = (this.props.paxDetailsValues === undefined) ? "" : this.props.paxDetailsValues.phone;

      this.props.initialize("PassengerDetails", {
        firstName:_filter(bookingGroup.passengers, 'email')[0].first_name,
        surname:_filter(bookingGroup.passengers, 'email')[0].family_name,
        phonePrefix:(_filter(bookingGroup.passengers, 'email')[0].telephone_country_code !== null) ? _filter(bookingGroup.passengers, 'email')[0].telephone_country_code : loadedPhonePrefix,
        phone:(_filter(bookingGroup.passengers, 'email')[0].telephone_number !== null) ? _filter(bookingGroup.passengers, 'email')[0].telephone_number: loadedPhone,
        email:_filter(bookingGroup.passengers, 'email')[0].email,
        dob:(this.props.paxDetailsValues === undefined) ? "" : this.props.paxDetailsValues.dob,
        nationality:(this.props.paxDetailsValues === undefined) ? "" : this.props.paxDetailsValues.nationality,
        state:(this.props.paxDetailsValues === undefined) ? "" : this.props.paxDetailsValues.state,
        sex:(this.props.paxDetailsValues === undefined) ? "" : this.props.paxDetailsValues.sex,
        phoneLockout:(_filter(bookingGroup.passengers, 'email')[0].telephone_number !== null) ? _filter(bookingGroup.passengers, 'email')[0].telephone_number: loadedPhone
      });


      this.props.initialize("PassengerBilling", {
        address:(this.props.paxBillingValues === undefined) ? "" : this.props.paxBillingValues.address,
        address2:(this.props.paxBillingValues === undefined )? "" : this.props.paxBillingValues.address2,
        city:(this.props.paxBillingValues === undefined) ? "" : this.props.paxBillingValues.city,
        postcode:(this.props.paxBillingValues === undefined) ? "" : this.props.paxBillingValues.postcode,
        country:(this.props.paxBillingValues === undefined) ? "" : this.props.paxBillingValues.country
      });

      //PassengerDetails dispatch hovered click state
      setTimeout(() => {

        _forEach(document.querySelectorAll('.passenger-details-item input'), item => {
          if(item.value !== "") {
            item.parentElement.parentElement.classList.add('hovered');
          }
        });

      },10);

    }
  }



  render(){

    return (
      <div className="passenger-details">
        <div className="row">
          <div className="column small-12">
              <PassengerDetailsItem nationality={this.props.nationality} nationalityState={this.props.nationalityState} stateVisible={this.state.stateVisible} currentState={this.state.currentState}/>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return{
    currency:state.currency,
    bookingGroup:state.bookingGroup.data,
    nationality:state.nationality,
    nationalityState:state.nationalityState,
    paxDetailsValues:getFormValues('PassengerDetails')(state),
    paxBillingValues:getFormValues('PassengerBilling')(state),
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    initialize,
    FetchNationality,
    FetchNationalityState
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PassengerDetails);



// WEBPACK FOOTER //
// ./src/components/payment/passengerdetails.js